module.exports = __webpack_public_path__ + "img/logo-gosuslugi-ru.87cf07a0.png";